import {
  SnackbarApiErrorMessage,
  useDataProvider,
  useEntityPermission,
  useLocalization,
  useSnackbar,
} from '@ui-framework/index';
import ListBoxSelector from '@product-framework/components/ListBoxSelector';
import { UnPaginatedList } from '@product-framework/index';

function IndustriesServicedSelector({
  onChange = () => undefined,
  permissions,
  config,
}) {
  const leftNameKey = 'industryName';
  const leftValueKey = 'id';
  const rightValueKey = 'id';
  const limit = 10;

  const { isReadOnly } = useEntityPermission();
  const readOnly = isReadOnly(permissions?.industryId, '');

  const { formatMessage } = useLocalization();
  const snackbar = useSnackbar();
  const industryMessages = config?.ui?.messages?.industriesServicedSelector;

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, post } = useDataProvider(provider);

  const rightTitle = formatMessage(industryMessages?.rightTitle);

  const getLeftItems = async page => {
    const response = await get(
      `${config?.api?.industriesServicedSelector?.listBoxLeft}?page=${page}&limit=${limit}`,
    );
    if (response.ok) {
      const { data = [], ...other } = response.data;
      const resultsData =
        data?.map(item => ({
          label: item[leftNameKey],
          value: item[leftValueKey],
          status: item.status,
        })) || [];

      return { data: resultsData, ...other };
    }
    snackbar.showMessage({
      type: 'error',
      data: <SnackbarApiErrorMessage errors={response?.errors} />,
    });
    return [];
  };

  const getRightItems = async page => {
    const response = await get(
      `${config?.api?.industriesServicedSelector?.listBoxRight}?page=${page}&limit=${limit}`,
    );
    if (response.ok) {
      const { data = [], ...other } = response.data;
      const resultsData =
        data?.map(item => ({
          label: item.industryName,
          value: item,
          status: item.status,
        })) || [];
      return { data: resultsData, ...other };
    }
    snackbar.showMessage({
      type: 'error',
      data: <SnackbarApiErrorMessage errors={response?.errors} />,
    });
    return { data: [] };
  };

  const onItemsAdded = async items => {
    if (Array.isArray(items)) {
      const response = await post(
        config?.api?.industriesServicedSelector?.listBoxAdd,
        {
          industryIds: items,
        },
      );
      if (!response.ok) {
        snackbar.showMessage({
          type: 'error',
          data: <SnackbarApiErrorMessage errors={response?.errors} />,
        });
      } else {
        snackbar.showMessage(formatMessage(industryMessages?.saveSuccess));
      }
    }
  };

  const onItemsRemoved = async items => {
    if (Array.isArray(items) && items.length > 0) {
      const industriesToRemove = items.map(item => item[rightValueKey]);
      const response = await post(
        `${config?.api?.industriesServicedSelector?.listBoxRemove}`,
        {
          industryIds: industriesToRemove,
        },
      );
      if (!response.ok) {
        snackbar.showMessage({
          type: 'error',
          data: <SnackbarApiErrorMessage errors={response?.errors} />,
        });
      } else {
        snackbar.showMessage(formatMessage(industryMessages?.removeSuccess));
      }
    }
  };

  if (readOnly) {
    return <UnPaginatedList title={rightTitle} getItems={getRightItems} />;
  }

  return (
    <ListBoxSelector
      height="390px"
      getLeftItems={getLeftItems}
      getRightItems={getRightItems}
      parentId={null}
      onChange={onChange}
      onItemsAdded={onItemsAdded}
      onItemsRemoved={onItemsRemoved}
      leftTitle={formatMessage(industryMessages?.leftTitle)}
      rightTitle={rightTitle}
    />
  );
}

export default IndustriesServicedSelector;
